import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AnaliseDesconto } from 'src/app/models/analise-desconto';
import { AnaliseDescontoStatus, StatusTarefa } from 'src/app/models/enum';
import { AnaliseDescontoConclusaoNegativaCampoPersonalizadoSelecionadoService } from 'src/app/services/analise-desconto-conclusao-negativa-campo-personalizado-selecionado.service';
import { AnaliseDescontoConclusaoPositivaCampoPersonalizadoSelecionadoService } from 'src/app/services/analise-desconto-conclusao-positiva-campo-personalizado-selecionado.service';
import { AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionadoService } from 'src/app/services/analise-desconto-solicitacao-campo-personalizado-selecionado.service';
import { AnaliseDescontoService } from 'src/app/services/analise-desconto.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-analise-desconto-conclusao-modal',
  templateUrl: './analise-desconto-conclusao-modal.component.html',
  styleUrls: ['./analise-desconto-conclusao-modal.component.scss']
})
export class AnaliseDescontoConclusaoModalComponent implements OnInit {

  analiseDesconto: AnaliseDesconto;
  tipoConclusao = 0; // 0 - Positiva | 1 - Negativa
  tabelas = [];
  service;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<AnaliseDescontoConclusaoModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private analiseDescontoService: AnaliseDescontoService, @Inject(MAT_DIALOG_DATA) public data: any,
    private analiseDescontoConclusaoPositivaCampoPersonalizadoSelecionadoService: AnaliseDescontoConclusaoPositivaCampoPersonalizadoSelecionadoService,
    private analiseDescontoConclusaoNegativaCampoPersonalizadoSelecionadoService: AnaliseDescontoConclusaoNegativaCampoPersonalizadoSelecionadoService,
    private pedidoService: PedidoService
  ) {
    if (this.data !== null && this.data !== undefined) {
      this.analiseDesconto = this.data.analiseDesconto;
      this.tipoConclusao = this.data.tipoConclusao;
      this.service = this.tipoConclusao === 0 ? this.analiseDescontoConclusaoPositivaCampoPersonalizadoSelecionadoService :
        this.analiseDescontoConclusaoNegativaCampoPersonalizadoSelecionadoService;
    }
  }

  ngOnInit() {
    this.montarCampos();
  }

  montarCampos() {
    this.carregandoService.mostra('montarCampos');
    this.service.montarParaCadastrar(this.analiseDesconto.id).subscribe(dados => {
      this.tabelas = dados;
      this.carregandoService.esconde('montarCampos');
    }, (erro) => {
      this.carregandoService.esconde('montarCampos');
      this.notificacaoService.erro(erro);
    });
  }

  async salvarQuestionario() {

    try {
      this.carregandoService.mostra('salvarQuestionario');
      await this.service.salvar(this.tabelas, this.analiseDesconto.id).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('salvarQuestionario');
    }
  }

  campoInvalido(f, campo) {
    const c = f.controls[campo];

    return c && c.invalid && (c.dirty || c.touched || f.submitted);
  }

  fechar() {
    this.dialogRef.close();
  }

  async salvar(f: NgForm) {

    if (f.invalid) {
      return;
    }

    swal({
      title: 'Atenção!!',
      html:
        'Deseja realmente <span class="negrito">concluir</span>?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        try {
          this.carregandoService.mostra('salvar');
          this.analiseDesconto.status = this.tipoConclusao === 0 ? AnaliseDescontoStatus.DescontoConcedido : AnaliseDescontoStatus.DescontoNaoConcedido;
          const resultado = await this.analiseDescontoService.salvar(this.analiseDesconto).toPromise();
          await this.salvarQuestionario();
          this.notificacaoService.sucesso('Análise Concluída com sucesso!!!');
          this.dialogRef.close(resultado);
        } catch (erro) {
          this.notificacaoService.erro('Erro ao salvar');
        } finally {
          this.carregandoService.esconde('salvar');
        }
      }
    });
  }
}
